/**
 * Upsell block — ajout au panier en AJAX.
 *
 * Délégation au niveau DOCUMENT (une seule fois) : fonctionne même quand un bloc
 * upsell est injecté APRÈS le chargement (drawer re-rendu en AJAX, panier vide au
 * 1er chargement, éditeur de thème). L'ancienne version attachait un listener par
 * conteneur au chargement du module -> les conteneurs ajoutés ensuite restaient inertes.
 */
(function () {
  if (window.__upsellDelegationReady) return;
  window.__upsellDelegationReady = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const btn = target.closest('.upsell-product__atc');
    if (!btn || btn.disabled) return;

    const container = btn.closest('[data-upsell-id]');
    if (!container) return;

    const bid = container.dataset.upsellId;
    const tAdd = container.dataset.tAdd;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.innerHTML = '…';

    // On demande le rendu des sections cart-items-component (drawer/panier) pour que
    // le drawer puisse se rafraîchir via le bon chemin. Sans ça, le drawer tombe sur
    // le rendu ?section_id (401 sur cette boutique) -> le contenu casse / disparaît.
    const sectionIds = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((c) => {
      if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((addResponse) =>
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            btn.innerHTML = '✓';
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: bid,
                  data: {
                    itemCount: cart.item_count,
                    variantId,
                    source: 'upsell-block',
                    sections: addResponse.sections,
                  },
                },
              })
            );
            setTimeout(() => {
              btn.disabled = false;
              btn.innerHTML = btn.dataset.icon;
            }, 2000);
          })
      )
      .catch(() => {
        btn.disabled = false;
        btn.textContent = tAdd;
      });
  });
})();
